export default __webpack_public_path__ + "images/mela-purchase/save-piggybank-6846708ae69cef2ffe8c40cb7c07b51f.svg";